module.exports = __webpack_public_path__ + "static/media/providem.1dbb2646.png";